export default "__VITE_ASSET__DbZOOTHP__"